import React, { useEffect, useState } from "react";

import InvestmentPreferenceContainer from "containers/Onboarding/InvestmentPreference";
import { useDispatch, useSelector } from "react-redux";
import AssessmentModal from "components/Assessment/AssessmentModal";
import { onboardingActions } from "stores/onboarding/onboardingActions";

const PortfolioInvestmentPreference = (props) => {
  const [openModal, setOpenModal] = useState(false);

  const getCurrentStage = useSelector((state) => state.onboarding.currentStage);
  const dispatch = useDispatch();
  useEffect(() => {
    if (getCurrentStage >= 1) {
      setOpenModal(true);
    }
  }, []);

  const handleClose = () => setOpenModal(false);

  const handleConfirm = () => {
    setOpenModal(false);
    dispatch(onboardingActions.updateOnboardingData({ currentStage: 0 }));
    window.location.reload();
  };

  return (
    <>
      <InvestmentPreferenceContainer />
      <AssessmentModal
        open={openModal}
        onClose={handleClose}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default PortfolioInvestmentPreference;
